import Leaflet from 'leaflet'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import User from '@/models/User'
import { GeoJSON } from 'geojson'

const viewportModule = namespace('viewport')

@Component
export default class BaseMapCanvas extends Vue {
	@viewportModule.Getter('isMobile')
	public readonly isMobile!: boolean

	@Prop({ required: false, default: () => [52.2639344, 6.7532569] })
	public readonly center!: any

	@Prop({ required: false, default: 10 })
	public readonly zoom!: number

	public map!: Leaflet.Map
	public centerAtVesselLocation = true

	public mounted(): void {
		this.map = new Leaflet.Map(this.$el as HTMLElement, { maxZoom: 21, zoomSnap: 0.5 })

		this.map.on('load', (): void => {
			this.$emit('map-load', this.map.getBounds())
		})

		this.map.setView(this.center, this.zoom)

		User.getCurrentVessels().then((vessels) => {
			if (!this.centerAtVesselLocation || !vessels.length) {
				return
			}

			const location = vessels[0].getLocation()
			if (!location) {
				return
			}

			const coordinates = (location as GeoJSON.Point).coordinates

			this.map.setView([coordinates[1], coordinates[0]], 10)
		})

		this.map.zoomControl.setPosition('bottomright')

		if (this.isMobile) {
			this.map.removeControl(this.map.zoomControl)
		}

		this.map.on('click', (event): void => {
			this.$emit('map-click', event)
		})

		this.map.on('moveend', (): void => {
			this.$emit('map-move', this.map.getBounds())
		})

		this.addBaseLayer()
	}

	public addBaseLayer(): void {
		if (window.localStorage.getItem('isTesting')) {
			return
		}

		const dimensionSuffix = BaseMapCanvas.isRetina() ? '@2x' : ''
		const type = 'mapbox/outdoors-v11'

		const mapbox = Leaflet.tileLayer(
			`https://api.mapbox.com/styles/v1/${type}/tiles/{z}/{x}/{y}${dimensionSuffix}?access_token=${process.env.VUE_APP_MAPBOX_TOKEN}`,
			{
				maxZoom: 21,
				minZoom: 1,
				tileSize: 512,
				zoomOffset: -1,
				attribution:
					'© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
			}
		)

		this.map.addLayer(mapbox)
	}

	public static isRetina(): boolean {
		const mediaQuery =
			'(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)'

		if (window.devicePixelRatio > 1) {
			return true
		}

		return window.matchMedia && window.matchMedia(mediaQuery).matches
	}
}
